import React from "react";
import PropTypes from "prop-types"
import {Table, Badge, Button} from 'antd';
import {NavLink} from "react-router-dom"
import {defaultPagination, onlyUnique, toFilterItem} from "../../util/Util"
import {uniq} from "lodash";

const CustomerTable = ({dataSource, onSelectChange, loading, toggleCreateDrawerVisibility, onEdit}) => {

    const columns = [
        {
            title: 'Status',
            dataIndex: 'active',
            render: active => <Badge status={active ? 'success' : 'default'}/>, width:60
        },
        {
            title: 'Reports',
            dataIndex: 'includeInReports',
            render: includeInReports => <Badge status={includeInReports ? 'success' : 'default'}/>, width:60
        },
        {title: 'Country', dataIndex: 'country', width:85,
            filters: uniq(dataSource.map(selection => selection.country)).sort().map(country => ({
                text: country,
                value: country,
            })),
            onFilter: (value, record) => record.country.indexOf(value) === 0
        },
        {title: 'Customer Code', dataIndex: 'code', width:170,
            filters: uniq(dataSource.map(selection => selection.code)).sort().map(code => ({
                text: code,
                value: code,
            })),
            onFilter: (value, record) => record.code.indexOf(value) === 0},
        {title: 'Name', dataIndex: 'name', width:400,
            filters: uniq(dataSource.map(selection => selection.name)).sort().map(name => ({
                text: name,
                value: name,
            })),
            onFilter: (value, record) => record.name.indexOf(value) === 0},
        {title: 'Call Name', dataIndex: 'callName', width: 300,
            filters: uniq(dataSource.map(selection => selection.callName)).sort().map(callName => ({
                text: callName,
                value: callName,
            })),
            onFilter: (value, record) => record.callName.indexOf(value) === 0},
        {title: 'Key Account Manager', dataIndex: 'kam', width: 200,
            filters: uniq(dataSource.map(selection => selection.kam)).sort().map(kam => ({
                text: kam,
                value: kam,
            })),
            onFilter: (value, record) => record.kam.indexOf(value) === 0},
        {
            title: '', render: (record, index) => <div className="crud-options">
                <Button icon="edit" size="small" shape="cicle" onClick={() => onEdit(record)} />
            </div>
        }
    ];
    
    return <div>
            <Button
                style={{
                    marginBottom: 8,
                    float: "right",
                }}
                onClick={toggleCreateDrawerVisibility}
            >Create New Customer</Button>
        <div style={{clear: 'both'}}>
        <Table dataSource={dataSource} loading={loading}
                  columns={columns} size="small" bordered
                  rowKey={record => record.id}
                  pagination={defaultPagination()}
    />
        </div>
    </div>
};

CustomerTable.propTypes = {
    dataSource: PropTypes.array.isRequired,
    onSelectChange: PropTypes.func,
    loading: PropTypes.bool.isRequired,
    toggleCreateDrawerVisibility: PropTypes.func.isRequired,
};

export default CustomerTable


// WEBPACK FOOTER //
// ./src/js/browse/customer/CustomerTable.js